import script from "./SurveyResponsesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyResponsesView.vue?vue&type=script&setup=true&lang=js"

import "./SurveyResponsesView.vue?vue&type=style&index=0&id=61f901f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f901f4"]])

export default __exports__